/**
 * Get the authentication token from the "sid" cookie
 * @returns {string|null} The token value or null if not found
 */
export const getAuthToken = () => {
  const cookies = document.cookie.split(';');
  const sidCookie = cookies.find(cookie => 
    cookie.trim().startsWith('sid=')
  );
  
  if (sidCookie) {
    return sidCookie.split('=')[1];
  }
  
  return null;
};

/**
 * Set the authentication token in the "sid" cookie
 * @param {string} token - The token to store
 * @param {Object} options - Cookie options (expires, path, domain, secure, sameSite)
 */
export const setAuthToken = (token, options = {}) => {
  const {
    expires = 7, // days
    path = '/',
    domain,
    secure = window.location.protocol === 'https:',
    sameSite = 'Lax'
  } = options;

  let cookieString = `sid=${token}; path=${path}`;
  
  if (expires) {
    const date = new Date();
    date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000));
    cookieString += `; expires=${date.toUTCString()}`;
  }
  
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  
  if (secure) {
    cookieString += '; secure';
  }
  
  if (sameSite) {
    cookieString += `; samesite=${sameSite}`;
  }
  
  document.cookie = cookieString;
};

/**
 * Remove the authentication token from cookies
 */
export const removeAuthToken = () => {
  document.cookie = 'sid=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
};

/**
 * Check if the user is authenticated (has a valid token)
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const token = getAuthToken();
  return token !== null && token !== undefined && token !== '';
};

/**
 * Get the current authentication status and token
 * @returns {Object} Object containing isAuthenticated boolean and token string
 */
export const getAuthStatus = () => {
  const token = getAuthToken();
  return {
    isAuthenticated: isAuthenticated(),
    token
  };
}; 